import { render, staticRenderFns } from "./dialog_template.vue?vue&type=template&id=5c5d5f3a&scoped=true&"
import script from "./dialog_template.vue?vue&type=script&lang=js&"
export * from "./dialog_template.vue?vue&type=script&lang=js&"
import style0 from "./dialog_template.vue?vue&type=style&index=0&id=5c5d5f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d5f3a",
  null
  
)

export default component.exports